export default __webpack_public_path__ + "static/media/Tryphena.ab3d83d6.jpg";